"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllNetworks = void 0;
const xahau_1 = require("./xahau");
const xrpl_1 = require("./xrpl");
const xevm_1 = require("./xevm");
const icons_1 = require("./common/icons");
const labels_1 = require("./common/labels");
const xahau = xahau_1.XahauNetwork.NetworkTypes;
const xrpl = xrpl_1.XrplLedgerNetwork.NetworkTypes;
const xevm = xevm_1.XevmNetwork.NetworkTypes;
const xahauExpl = xahau_1.XahauNetwork.Explorers;
const xrplExpl = xrpl_1.XrplLedgerNetwork.Explorers;
const xevmExpl = xevm_1.XevmNetwork.Explorers;
const AllNodeTypes = {
    xahau,
    xrpl,
    xevm,
};
const AllNodeExplorers = {
    xahauExpl,
    xrplExpl,
    xevmExpl,
};
class AllNetworks {
    static Xahau = xahau_1.XahauNetwork;
    static XrplLedger = xrpl_1.XrplLedgerNetwork;
    static Xevm = xevm_1.XevmNetwork;
    static AllNodeTypes = AllNodeTypes;
    static AllNodeExplorers = AllNodeExplorers;
    static NetworkLabels = labels_1.NetworkLabels;
    static NetworkIcons = icons_1.NetworkIcons;
}
exports.AllNetworks = AllNetworks;
//# sourceMappingURL=index.js.map